<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="请输入承诺标题或发起人"
        v-model.trim="searchName"
        class="handle-input mr10"
      ></el-input>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="getData(1)"
        size="small"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column header-align="center" prop="name" label="承诺标题">
      </el-table-column>
      <el-table-column
        prop="targetName"
        align="center"
        label="发起人"
      ></el-table-column>
      <el-table-column align="center" label="发布时间" width="180px">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.time, "yyyy-MM-dd hh:mm") }}
        </template>
      </el-table-column>
      <el-table-column label="承诺类型" align="center" :formatter="type">
      </el-table-column>
      <el-table-column label="承诺详情" align="center">
        <template #default="scope">
          <el-button size="mini" type="primary" @click="info(scope.row)"
            >承诺详情</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="审核操作" width="180" align="center">
        <template #default="scope">
          <el-button
            type="success"
            size="mini"
            @click="handleEdit(scope.row, 1)"
            >通过</el-button
          >
          <el-button type="danger" size="mini" @click="handleEdit(scope.row, 2)"
            >驳回</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>

    <!-- 详情 -->
    <el-dialog
      title="承诺详情"
      v-model="dialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="event_wrap">
        <el-form size="mini" inline>
          <div>
            <el-form-item>{{ itemData.name }}</el-form-item>
          </div>
          <div>
            <el-form-item>{{ itemData.targetName }}</el-form-item>
          </div>
          <div>
            <el-form-item
              >{{ $utils.formatDate(itemData.startTime, "yyyy-MM-dd hh:mm") }}~
              {{
                $utils.formatDate(itemData.endTime, "yyyy-MM-dd hh:mm")
              }}</el-form-item
            >
          </div>
          <div>
            <el-form-item label="公开展示：">{{ type(itemData) }}</el-form-item>
          </div>
          <div>
            <el-form-item label="是否允许个人加入：">{{ itemData.xinfuPersonJoin?'是':'否' }}</el-form-item>
          </div>
          <div v-if="itemData.type === 2">
            <el-form-item label="信用条件：">
              <div>
                <li v-for="item in itemData.certificationYear" :key="item">
                  {{ item }}年诚信认证
                </li>
                <li v-if="itemData.assess > 0">
                  信夫{{ assess(itemData) }}:{{
                    assessScore(itemData.assessScore)
                  }}
                </li>
                <li v-if="itemData.xinfuPersonJoin">
                  个人信夫{{itemData.xinfuPersonChoose===1?'信贷分':'职信分'}}：{{assessScore(itemData.xinfuPersonScore)}}
                </li>
              </div>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="声明：">{{ itemData.statement }}</el-form-item>
          </div>
          <div>
            <el-form-item label="承诺内容：">{{
              itemData.content
            }}</el-form-item>
          </div>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      searchName: "",
      dialogVisible: false,
      itemData: {},
    };
  },
  methods: {
    async getData(page = 1) {
      if (this.searchName.length > 30) {
        this.$message.warning("搜索内容最多输入30个字");
        return;
      }
      const params = {
        name: this.searchName,
        currentPage: page,
        pageSize: 20,
      };
      try {
        this.$loading.start();
        const res = await this.$api.promise.review.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    type(data) {
      switch (data.type) {
        case 1:
          return "内部承诺";
        case 2:
          return "社会承诺";
        default:
          return "-";
      }
    },
    assess(data) {
      switch (data.assess) {
        case 1:
          return "履约分";
        case 2:
          return "信贷分";
        case 3:
          return "综合分";
        default:
          return "-";
      }
    },
    assessScore(val) {
      switch (val) {
        case 1:
          return "200分以上";
        case 2:
          return "400分以上";
        case 3:
          return "600分以上";
        case 4:
          return "800分以上";
        default:
          return "-";
      }
    },
    handleEdit(data, status) {
      if (!this.loading) {
        const text =
          status === 1 ? "是否确认通过审核？" : "是否确认不通过审核？";
        this.$confirm(text, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            try {
              this.loading = true;
              this.$loading.start();
              const params = {
                id: data.id,
                targetType: data.targetType,
                type: data.type,
                status: status,
              };
              const res = await this.$api.promise.review.setData(params);
              this.loading = false;
              this.$loading.done();
              if (res.code === 10200) {
                this.getData(this.data.current);
                if (status === 1) {
                  this.$message.success("通过成功");
                } else {
                  this.$message.success("驳回成功！");
                }
              } else {
                this.$message.error(res.msg);
              }
            } catch (error) {
              this.loading = false;
              this.$loading.done();
            }
          })
          .catch(() => {});
      }
    },
    info(data) {
      this.itemData = { ...data };
      this.itemData.certificationYear = data.certificationYear
        ? data.certificationYear.split(",")
        : [];
      this.dialogVisible = true;
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 200px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;

  .el-select {
    width: 180px;
  }
}

.cover {
  width: 160px;
  height: 90px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.video {
  height: 500px;
}

.event_wrap {
  .cover-title {
    display: flex;

    .cover {
      margin-right: 24px;
    }

    .title-name {
      li {
        line-height: 26px;
      }
    }
  }

  .el-form-item {
    margin-bottom: 0;
  }

  .remark {
    .title {
      margin: 24px 0;
      padding-left: 10px;
      font-size: 1.125rem;
      border-left: 2px solid #409eff;
    }

    .remark-content {
      font-size: 0.875rem;
      p {
        line-height: 26px;
      }
      img {
        max-width: 100%;
      }
    }
  }
}
</style>